import { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useUser } from "../../user_context";
import './css/js_layout.css';




const NAV_ITEMS = [
  { id: "dashboard",    path: "/dashboard",     icon: "◈",    label: "Dashboard" },
  { id: "jobs",         path: "/jobs",          icon: "✦",     label: "Browse Jobs" },
  { id: "search",       path: "/search",        icon: "🔍",   label: "Find Employers" },
  { id: "applications", path: "/applications",  icon: "◻",    label: "My Applications"},
  { id: "saved",        path: "/saved-jobs",    icon: "♡",     label: "Saved Jobs" },
  { id: "profile",      path: "/profile",       icon: "◯",    label: "My Profile" },
  // { id: "portfolio",    path: "/portfolio",           icon: "◑", label: "Portfolio" },
  // { id: "messages",     path: "/messages",            icon: "✉", label: "Messages",          badge: "2" },
  // { id: "settings",     path: "/settings",            icon: "⚙", label: "Settings" },
];

const BOTTOM_NAV = [
  { id: "dashboard",    path: "/dashboard", icon: "◈", label: "Home" },
  { id: "jobs",         path: "/jobs",                icon: "✦", label: "Jobs" },
  { id: "search",       path: "/search",        icon: "🔍",   label: "Employers" },
  { id: "applications", path: "/applications",        icon: "◻", label: "Applications" },
  // { id: "messages",     path: "/messages",            icon: "✉", label: "Messages", badge: "2" },
  { id: "profile",      path: "/profile",             icon: "◯", label: "Profile" },
];

export default function JSLayout({ children, title, titleEm, topbarRight }) {
  const navigate   = useNavigate();
  const location   = useLocation();
  const [open, setOpen] = useState(false);
  const { userData, loading } = useUser();
  const active = (path) => location.pathname === path;


  // console.log("User Data in Layout:", userData);
  useEffect(() => {
    if (!loading && !userData) {
      navigate("/signin", { replace: true });
    }
    const token = localStorage.getItem("token");
    if (!token && userData) {
      window.location.href = "/signin";
    }
  }, [userData, loading, navigate]);

  if (loading) {
    return (
      <div className="layout-loading-screen">
        <div className="spinner">Loading your profile...</div>
      </div>
    );
  }

  if (!userData) return null;

  return (
    <div className="bl-layout-root">
      {/* overlay */}
      <div className={`bl-overlay${open ? " open" : ""}`} onClick={() => setOpen(false)} />

      {/* sidebar */}
      <aside className={`bl-sidebar${open ? " open" : ""}`}>
        <Link to="/" className="bl-logo">Rembo<span>List</span></Link>

        <div className="bl-nav-label">Main</div>
        {NAV_ITEMS.slice(0, 5).map(n => (
          <Link key={n.id} to={n.path} className={`bl-nav-item${active(n.path) ? " active" : ""}`} onClick={() => setOpen(false)}>
            <span className="bl-nav-icon">{n.icon}</span>
            {n.label}
            {n.badge && <span className="bl-nav-badge">{n.badge}</span>}
          </Link>
        ))}

        {/* <div className="bl-nav-label">Profile</div>
        {NAV_ITEMS.slice(4, 7).map(n => (
          <Link key={n.id} to={n.path} className={`bl-nav-item${active(n.path) ? " active" : ""}`} onClick={() => setOpen(false)}>
            <span className="bl-nav-icon">{n.icon}</span>
            {n.label}
            {n.badge && <span className="bl-nav-badge">{n.badge}</span>}
          </Link>
        ))} */}

        {/* <div className="bl-nav-label">Account</div>
        {NAV_ITEMS.slice(7).map(n => (
          <Link key={n.id} to={n.path} className={`bl-nav-item${active(n.path) ? " active" : ""}`} onClick={() => setOpen(false)}>
            <span className="bl-nav-icon">{n.icon}</span>
            {n.label}
          </Link>
        ))} */}

        <div className="bl-sidebar-footer">
          <div className="bl-user-chip">
            <div className="bl-avatar">{loading ? ".." :userData?.initials || "--"}</div>
            <div>
              <div className="bl-user-name">{loading ? ".." :userData?.displayName || "User"}</div>
              <div className="bl-user-role">{loading ? ".." :userData?.specialisation || "--"}</div>
            </div>
          </div>
          <button className="bl-signout" onClick={() => navigate("/signin")}>↩ Sign out</button>
        </div>
      </aside>

      {/* topbar */}
      <header className="bl-topbar">
        <div className="bl-topbar-left">
          <button className="bl-hamburger" onClick={() => setOpen(true)} aria-label="Menu">☰</button>
          <div className="bl-topbar-title">{title}{titleEm && <> — <em>{titleEm}</em></>}</div>
        </div>
        <div className="bl-topbar-right">
          {topbarRight}
          {/* <button className="bl-notif-btn">🔔<span className="bl-notif-dot" /></button> */}
          <div className="bl-avatar">{loading ? ".." :userData?.initials || "--"}</div>
        </div>
      </header>

      {/* page content */}
      <main className="bl-main">{children}</main>

      {/* bottom nav */}
      <nav className="bl-bottom-nav">
        <div className="bl-bottom-nav-inner">
          {BOTTOM_NAV.map(n => (
            <Link key={n.id} to={n.path} className={`bl-bn-item${active(n.path) ? " active" : ""}`}>
              {n.badge && <span className="bl-bn-badge">{n.badge}</span>}
              <span className="bl-bn-icon">{n.icon}</span>
              <span className="bl-bn-label">{n.label}</span>
            </Link>
          ))}
        </div>
      </nav>
    </div>
  );
}
